<template>
    <div class="container-fluid">
        <div v-if="errors && errors.length > 0" class="alert alert-danger">
            {{ getErrorsText }}
        </div>
        <h4 class="mb-5 mr-5">Добавление транспортной компании</h4>
        <el-form ref="form" :model="form" label-position="left" label-width="220px" id="uploadForm" name="uploadForm"
                 enctype="multipart/form-data">
            <el-form-item label="Название">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="Стоимость">
                <el-input v-model="form.price"></el-input>
            </el-form-item>
            <el-form-item label="Минимальная сумма заказа">
                <el-input v-model="form.minTotalForFree"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="add()">Добавить</el-button>
                <el-button @click="back()">Отмена</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import axios from "axios";
import getErrors, { getTextErrors } from '../../composable/utils/getErrors';
import useFormData from '../../composable/useFormData'

export default {
    data() {
      return {
        form: {
          name: '',
          price: '',
          minTotalForFree: '',
        },
        errors: [],
      }
    },
    computed: {
      getErrorsText() {
        if (this.errors && this.errors.length > 0) {
          return getTextErrors(this.errors)
        }
        return ''
      }
    },
    methods: {
      back() {
          this.$router.go(-1);
      },
      add() {
        const { execute } = useFormData()

        const data = execute().setFields([
          'name',
          'price',
          'minTotalForFree',
        ]).getFormData(this.form)


          axios.post('/transport-company', data).then(() => {
            this.back();
          }).catch((errors) => {
              this.errors = errors.response.data.errors;
              if (errors.response.status === 401) {
                  this.$router.push('/login');
              }
              if(errors.response.status === 422) {
                this.setErrors(errors.response.data.errors)
              }
          });
      },

      setErrors(err) {
        this.errors = getErrors(err)
      }

    }
}
</script>

<style scoped>

</style>